module.exports = __webpack_public_path__ + "img/pzds_icon.8b5c548.png";